import { Component, OnInit, Input } from '@angular/core';
import { Dictionary, Contact } from '@akiba/models_bimbo';
import { LogicService } from '../../../services/logic.service';


@Component({
  selector: 'app-contact-information',
  templateUrl: './contact-information.component.html',
  styleUrls: ['./contact-information.component.scss']
})
export class ContactInformationComponent implements OnInit {

  @Input() disabled: boolean;
  @Input() contactInformation: Dictionary<Contact>;
  constructor(private appLogic: LogicService) {

  }

  ngOnInit() {
  }

}
